export enum actionTypes {
    SET_JACKPOTS = 'JACKPOT:JACKPOTS:SET',
    CLEAR_JACKPOTS = 'JACKPOT:JACKPOTS:CLEAR',
    SET_TOTAL_CASINO_JACKPOT = 'JACKPOT:TOTAL_CASINO_JACKPOT:SET'
}
